import { Box } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useTimer from 'src/common/hooks/useTimer';
import ConditionalWrapper from 'src/components/ConditionalWrapper';
import { NODE_ENV } from 'src/config';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import AuthStepperFooter from 'src/features/auth/presentation/components/AuthStepperFooter/AuthStepperFooter';
import VerificationOtpInput from 'src/features/auth/presentation/components/VerificationStepper/VerificationOtpInput';
import { useAuthenticationOtpMutations } from 'src/features/verification/presentation/hooks/useAuthenticationOtpMutations';
import { useVerificationToken } from 'src/features/auth/presentation/providers/VerificationTokenProvider';
import LoaderOverlay from 'src/components/Loader';

export const VerificationScreen = () => {
  const { isMobile, alertNotification } = useAppUI();
  const navigate = useNavigate();
  const [hasSentCode, setHasSentCode] = useState(true);
  const [isError, setIsError] = useState(false);
  const { verifyLoginOtpMutation, sendLoginOtpMutation } =
    useAuthenticationOtpMutations();
  const { decodedUser } = useVerificationToken();

  const { time, resetTimer, formattedTimer } = useTimer({
    enabled: hasSentCode,
    initialTime: NODE_ENV === 'development' ? 5000 : 30000,
  });

  const enableRequestNewCode = !time || time === 0;

  const handleResendCode = async () => {
    if (!decodedUser) return;

    await sendLoginOtpMutation.mutateAsync(
      {
        phone_number: decodedUser.phone_number,
        email: decodedUser.email,
        type: 'AUTHENTICATION',
      },
      {
        onSuccess: () => {
          setHasSentCode(true);
          resetTimer();
        },
        onError: () =>
          alertNotification.error('Ocurrió un error al enviar el código.'),
      }
    );
  };

  const handleVerifyOtp = async (otp: string) => {
    if (!decodedUser) return;

    await verifyLoginOtpMutation.mutateAsync(
      {
        phone_number: decodedUser.phone_number,
        email: decodedUser.email,
        code: otp,
        type: 'AUTHENTICATION',
      },
      {
        onSuccess: () => {
          navigate(`/specialized-stores/products`);
        },
        onError: () => setIsError(true),
      }
    );
  };

  if (!decodedUser) {
    return <LoaderOverlay />;
  }

  return (
    <Box>
      <VerificationOtpInput
        onSubmit={handleVerifyOtp}
        onResendCode={handleResendCode}
        enableRequestNewCode={enableRequestNewCode}
        timeToResend={formattedTimer}
        isError={isError}
        isPending={verifyLoginOtpMutation.isPending}
        to="tu correo y teléfono"
      />
      <ConditionalWrapper
        condition={isMobile}
        wrapper={(children) => (
          <Box position="fixed" bottom={0} left={0} right={0} px={2} pb={5}>
            {children}
          </Box>
        )}
      >
        <AuthStepperFooter
          containerProps={{ mt: isMobile ? 'auto' : 4 }}
          backButton={{
            onClick: () => navigate('/specialized-stores/welcome'),
            label: 'Regresar',
            variant: 'text',
          }}
        />
      </ConditionalWrapper>
    </Box>
  );
};
